import React, { PureComponent } from 'react';
import { Select, DatePicker } from 'antd';
import moment from 'moment';

const { Option } = Select;
const { RangePicker } = DatePicker;

export const DATE_FILTERS = {
  LAST_7_DAYS: 'last_7_days',
  LAST_14_DAYS: 'last_14_days',
  LAST_30_DAYS: 'last_30_days',
  CUSTOM: 'custom',
};

const dateFilter = numDays => [
  moment().subtract(numDays, 'days').startOf('day'),
  moment().endOf('day'),
];

const getDateRangeByFilter = {
  [DATE_FILTERS.LAST_7_DAYS]: () => dateFilter(6),
  [DATE_FILTERS.LAST_14_DAYS]: () => dateFilter(13),
  [DATE_FILTERS.LAST_30_DAYS]: () => dateFilter(29),
};

class DateRangeFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedFilter: DATE_FILTERS.LAST_7_DAYS,
      customRange: [],
    };
  }

  componentDidMount() {
    this.emitRange(this.state.selectedFilter, []);
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedFilter, customRange } = this.state;

    if (
      prevState.selectedFilter !== selectedFilter
      || (selectedFilter === DATE_FILTERS.CUSTOM && customRange !== prevState.customRange)
    ) {
      this.emitRange(selectedFilter, customRange);
    }
  }

  emitRange = (filter, customRange) => {
    let from;
    let to;

    if (filter === DATE_FILTERS.CUSTOM) {
      if (customRange.length !== 2) return;
      from = customRange[0].startOf('day');
      to = customRange[1].endOf('day');
    } else {
      const getRange = getDateRangeByFilter[filter];
      if (!getRange) return;
      [from, to] = getRange();
    }

    if (from && to && this.props.onChange) {
      this.props.onChange(from.toISOString(), to.toISOString());
    }
  };

  handleFilterChange = value => {
    this.setState({ selectedFilter: value, customRange: [] });
  };

  handleCustomRangeChange = dates => {
    this.setState({ customRange: dates });
  };

  disableFutureDates = current => current && current > moment().endOf('day');

  render() {
    const { selectedFilter, customRange } = this.state;

    return (
      <div>
        <Select
          style={{ width: '240px' }}
          value={selectedFilter}
          onChange={this.handleFilterChange}
        >
          <Option value={DATE_FILTERS.LAST_7_DAYS}>Last 7 Days</Option>
          <Option value={DATE_FILTERS.LAST_14_DAYS}>Last 14 Days</Option>
          <Option value={DATE_FILTERS.LAST_30_DAYS}>Last 30 Days</Option>
          <Option value={DATE_FILTERS.CUSTOM}>Custom</Option>
        </Select>

        {selectedFilter === DATE_FILTERS.CUSTOM && (
          <RangePicker
            value={customRange}
            onChange={this.handleCustomRangeChange}
            disabledDate={this.disableFutureDates}
            style={{ marginTop: '4px' }}
          />
        )}
      </div>
    );
  }
}

export { DateRangeFilter };
